import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './ImageLightbox.scss';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock';

interface ImageLightboxProps {
    src: string;
    onClose: () => void;
}

export const ImageLightbox = ({ src, onClose }: ImageLightboxProps) => {
    useBodyScrollLock();

    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [onClose]);

    return ReactDOM.createPortal(
        <div className="image-lightbox-overlay" onClick={onClose}>
            <button className="image-lightbox-close" onClick={onClose} aria-label="Close">✕</button>
            <img
                className="image-lightbox-img"
                src={src}
                alt=""
                onClick={(e) => e.stopPropagation()}
            />
        </div>,
        document.body
    );
};

export default ImageLightbox;
